export default "__VITE_ASSET__B_UBq7Gh__"